import { HttpClientModule, HTTP_INTERCEPTORS, } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './Core/interceptors/token.interceptor';
import { SharedModule } from './shared/shared.module';
import { ActivityTrackingComponent } from './Core/activity-tracking/activity-tracking.component';
import { TracingService } from './Core/services/tracing.service';

@NgModule({
  declarations: [AppComponent, ActivityTrackingComponent,],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(tracingService: TracingService) {
    tracingService.traceEvent(`App Root Module: ${localStorage.getItem('lang')}`);
  }
}
